import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { ArrowLeft, Package, Store } from "lucide-react";

export default function ProductDetail() {
  const { id } = useParams();
  const [producto, setProducto] = useState(null);
  const [tienda, setTienda] = useState(null);
  const [qty, setQty] = useState(1);
  const { add } = useCart();

  useEffect(() => {
    api.get(`/productos/${id}`).then(async r => {
      setProducto(r.data);
      const t = await api.get(`/tiendas/${r.data.tienda_id}`);
      setTienda(t.data);
    });
  }, [id]);

  if (!producto) return <div className="min-h-screen bg-[#F9F9F8]"><Navbar /><div className="p-16 text-center text-zinc-500">Cargando…</div></div>;

  const agotado = !producto.estado_disponible || producto.stock_disponible === 0;

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <Navbar />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-600 hover:text-zinc-900 mb-6" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Volver al catálogo
        </Link>
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="aspect-square bg-white border border-zinc-200 rounded-sm overflow-hidden">
            {producto.imagen_url && <img src={producto.imagen_url} alt={producto.nombre} className="w-full h-full object-cover" />}
          </div>
          <div>
            <div className="overline text-zinc-500">{producto.categoria}</div>
            <h1 className="font-display font-black text-3xl lg:text-5xl tracking-tighter mt-2">{producto.nombre}</h1>
            {tienda && (
              <Link to={`/t/${tienda.id}`} data-testid="detail-store-link" className="mt-3 inline-flex items-center gap-2 text-sm text-zinc-600 bg-white border border-zinc-200 rounded-sm px-3 py-1.5 hover:border-[#FF3366] hover:text-[#FF3366]">
                <Store className="w-3.5 h-3.5" /> {tienda.nombre_local}{tienda.numero_local && tienda.numero_local !== "N/A" ? ` · Local ${tienda.numero_local}` : ""} · Conoce la tienda online del anunciante
              </Link>
            )}
            <div className="mt-6 font-display font-black text-4xl tracking-tight">${producto.precio.toFixed(2)}</div>
            <p className="mt-4 text-zinc-700 leading-relaxed">{producto.descripcion}</p>
            <div className="mt-6 flex items-center gap-2 text-sm">
              <Package className="w-4 h-4 text-zinc-500" />
              <span className={agotado ? "text-red-600 font-medium" : producto.stock_disponible < 3 ? "text-amber-600 font-medium" : "text-emerald-700"}>
                {agotado ? "Agotado" : `${producto.stock_disponible} disponibles`}
              </span>
            </div>
            <div className="mt-8 flex items-center gap-3">
              <div className="flex items-center border border-zinc-300 rounded-sm">
                <button data-testid="qty-minus" onClick={() => setQty(Math.max(1, qty - 1))} className="w-10 h-11 hover:bg-zinc-100">−</button>
                <div className="w-12 text-center font-medium" data-testid="qty-value">{qty}</div>
                <button data-testid="qty-plus" onClick={() => setQty(qty + 1)} className="w-10 h-11 hover:bg-zinc-100">+</button>
              </div>
              <Button
                data-testid="detail-add-to-cart"
                disabled={agotado}
                onClick={() => {
                  const ok = add(producto, qty);
                  if (ok !== false) toast.success("Agregado al carrito");
                }}
                className="rounded-sm h-11 bg-[#FF3366] hover:bg-[#E62958] text-white px-8 flex-1"
              >
                Agregar al carrito
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
